import React, { useEffect } from "react";
import Nav from "./Nav";
import Footer from "./Footer";
import Reactplayer from "./ReactPlayer";
import ReviewCard from "./ReviewCard";
import { Link } from "react-router-dom";
import CommentImg from "./CommentImg";
import AOS from "aos";
import "aos/dist/aos.css";

const Reviews = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div>
      <Nav active="reviews" />
      <div className="bg-[#fff] border-8 border-red-600">
        <div className=" max-w-[800px] mx-auto px-5 pt-8 pb-20">
          <div className="relative">
            <h1 className="md:text-[45px] text-center text-[30px] font-bold md:leading-[60px] mb-8 leading-[40px] text-[#1b0c3e] mt-3">
              What our clients say about us
            </h1>
            <div className="left-0 right-0 mt-16 lg:mt-0 lg:absolute top-36 md:px-10">
              <Reactplayer url="https://www.youtube.com/watch?v=vNx2Z7ePCoM&t=4s" />
            </div>
          </div>
        </div>

        <img
          src={require("../images/mountain.png")}
          alt=""
          className="w-[100vw] h-[400px] hidden lg:block mt-20"
        />
        <div className="bg-white">
          <div className="flex flex-wrap py-10 mt-12 justify-around xl:justify-between mx-auto px-4 max-w-[1320px] ">
            <ReviewCard />
          </div>
        </div>

        <div className="pt-20 bg-white">
          <CommentImg img={require("../images/commentsImg3.png")} />
        </div>

        <div
          data-aos="fade-up"
          data-aos-delay="200"
          data-aos-duration="1000"
          className="bg-[#fff] pb-20"
        >
          <div className=" max-w-[1000px] mx-auto px-5 pt-24 pb-20">
            <h1 className="md:text-[43px] text-[30px] text-center  font-bold md:leading-[60px] mb-8 leading-[40px] text-[#1b0c3e] mt-3">
              Let us take your editing workload off your hands
            </h1>
            <p className="mt-4 mb-6 text-2xl  text-[#4f4f4f] text-center ">
              Meet your new personal video editing team today.
            </p>
          </div>
          <div className="pb-10 -mt-12 text-center ">
            <Link to="/how-it-works">
              <button className="md:py-4 md:px-6 p-3 m-1  md:text-2xl text-xl font-semibold bg-[#508dff] transition duration-200 ease-out text-[#fff] rounded-md text-center mx-auto hover:shadow-2xl">
                Get your videos edited
              </button>
            </Link>
            <p className="mt-4 mb-6 text-lg  text-[#4f4f4f]  text-center ">
              Action based money back guarantee
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Reviews;
